// import PropTypes from 'prop-types';
import { parse as parseQuery } from 'query-string';
import React, { useState, useRef, useEffect } from 'react';
import { Switch, Route, useLocation } from 'react-router';

import * as AppPropTypes from '../lib/PropTypes';

import { useRoutes } from '../contexts/RoutesContext';
// import AccountPage from './pages/AccountPage';
import EmailConfirmed from './pages/EmailConfirmedPage';
import ErrorPage from './pages/ErrorPage';
import ForgotPassword from './pages/ForgotPasswordPage';
import LoginPage from './pages/LoginPage';
import PageLoader from './pages/PageLoader';
import ProfileDeletePage from './pages/ProfileDeletePage';
import ProfilePage from './pages/ProfilePage';
import ResetPassword from './pages/ResetPasswordPage';
import SetEmail from './pages/SetEmailPage';

import '../../styles/main.scss';

const propTypes = {
    // locale: PropTypes.string,
    statusCode: AppPropTypes.statusCode,
    // indexSlugs: PropTypes.objectOf(PropTypes.string),
};

const defaultProps = {
    // locale: 'fr',
    statusCode: null,
    // indexSlugs: null,
};

const App = ({ statusCode: initialStatusCode }) => {
    const routes = useRoutes();
    const [statusCode, setStatusCode] = useState(initialStatusCode); // eslint-disable-line no-unused-vars
    const location = useLocation();
    const initialLocationRef = useRef(location);

    useEffect(() => {
        if (initialLocationRef.current !== location) {
            setStatusCode(null);
        }
    }, [location]);

    // console.log(routes);

    return (
        <Switch>
            {statusCode !== null ? (
                <Route path="*" render={() => <ErrorPage statusCode={statusCode} />} />
            ) : null}

            <Route path={routes.home} exact component={PageLoader} />

            {/* Auth */}
            <Route
                path={routes.login}
                exact
                render={({ location: { search } }) => {
                    const { loginOnly = false } = parseQuery(search) || {};
                    return <LoginPage withoutRegister={loginOnly === 'true'} />;
                }}
            />
            <Route path={routes.register} exact component={LoginPage} />
            <Route path={routes['register.email']} exact component={SetEmail} />
            <Route path={routes['email.confirmed']} exact component={EmailConfirmed} />
            <Route path={routes['password.request']} exact component={ForgotPassword} />
            <Route path={routes['password.reset']} exact component={ResetPassword} />

            <Route path={[routes['account.profile']]} exact component={ProfilePage} />
            <Route path={[routes['account.delete']]} exact component={ProfileDeletePage} />
            <Route path={[routes['account.section']]} exact component={PageLoader} />

            <Route
                path={[
                    // routes.index_with_film_bundle_and_edition,
                    routes.index_with_scope_and_edition,
                    routes.index_with_taxonomy_and_edition,
                    routes.section_with_type,
                    routes.section_with_type_and_edition,
                    routes.section_with_edition,
                    routes.section,
                    routes.index_with_scope,
                    routes.index_with_child_index,
                    routes.index_with_taxonomy,
                    routes.index_with_film_bundle,
                    routes.index_edition,
                    routes.index,
                ]}
                exact
                // render={({
                //     match: {
                //         params: { index = null },
                //     },
                // }) => (
                //     <PageLoader
                //     // withQuery={
                //     //     (Object.keys(indexSlugs).find((it) => indexSlugs[it] === index) ||
                //     //         null) !== 'search'
                //     // }
                //     />
                // )}
                component={PageLoader}
            />
            <Route
                path={[
                    routes.tickets,
                    routes.film,
                    routes.event,
                    routes['event.tickets'],
                    routes.article,
                    routes.page,
                    routes['page.section'],
                ]}
                exact
                component={PageLoader}
            />
            <Route path="*" component={ErrorPage} />
        </Switch>
    );
};

App.propTypes = propTypes;
App.defaultProps = defaultProps;

export default App;
